import { render, staticRenderFns } from "./CategoryEditor.vue?vue&type=template&id=caef819c&"
import script from "./CategoryEditor.vue?vue&type=script&lang=js&"
export * from "./CategoryEditor.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEditor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports